var _path, _path2, _path3, _rect, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRar = function SvgRar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#rar_svg__a)",
    d: "M9 7.5A4.5 4.5 0 0 1 13.5 3H30c8.284 0 15 6.716 15 15v22.5a4.5 4.5 0 0 1-4.5 4.5h-27A4.5 4.5 0 0 1 9 40.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#C0BEBE",
    d: "M15 31.569a1.5 1.5 0 0 1 1.5-1.5h6v3h-6a1.5 1.5 0 0 1-1.5-1.5M31.5 30.069h6a1.5 1.5 0 1 1 0 3h-6zM15 25.5a1.5 1.5 0 0 1 1.5-1.5h6v4.5h-6A1.5 1.5 0 0 1 15 27zM15 36a1.5 1.5 0 0 1 1.5-1.5h6V39h-6a1.5 1.5 0 0 1-1.5-1.5zM31.5 24h6a1.5 1.5 0 0 1 1.5 1.5V27a1.5 1.5 0 0 1-1.5 1.5h-6zM31.5 34.5h6A1.5 1.5 0 0 1 39 36v1.5a1.5 1.5 0 0 1-1.5 1.5h-6zM24 24h4.5v1.5H24zM24 30h4.5v1.5H24zM24 27h4.5v1.5H24zM24 33h4.5v1.5H24zM25.5 25.5H30V27h-4.5zM25.5 31.5H30V33h-4.5zM25.5 28.5H30V30h-4.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#C0BEBE",
    fillRule: "evenodd",
    d: "M30 34.5h-6V39h6zM28.5 36h-3v1.5h3z",
    clipRule: "evenodd"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25.5,
    height: 12,
    x: 3,
    y: 9,
    fill: "#99186E",
    rx: 4.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.343 18v-6h2.59q.668 0 1.169.243.5.244.779.7.278.457.278 1.096 0 .645-.287 1.087-.285.443-.8.668-.511.226-1.198.226H8.327v-1.266h1.219q.287 0 .49-.07a.62.62 0 0 0 .313-.232.7.7 0 0 0 .111-.413.72.72 0 0 0-.111-.419.62.62 0 0 0-.314-.24 1.3 1.3 0 0 0-.489-.08h-.574V18zm3.515-2.754 1.5 2.754H10.59l-1.465-2.754zM14.413 18h-1.758l1.98-6h2.227l1.98 6h-1.757l-1.312-4.348h-.047zm-.328-2.367h3.305v1.219h-3.305zM19.42 18v-6h2.59q.668 0 1.169.243.5.244.779.7.278.457.278 1.096 0 .645-.287 1.087-.285.443-.8.668-.511.226-1.198.226h-1.547v-1.266h1.219q.286 0 .49-.07a.62.62 0 0 0 .313-.232.7.7 0 0 0 .111-.413.72.72 0 0 0-.111-.419.62.62 0 0 0-.314-.24 1.3 1.3 0 0 0-.49-.08h-.573V18zm3.515-2.754 1.5 2.754h-1.77l-1.464-2.754z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "rar_svg__a",
    x1: 9,
    x2: 45,
    y1: 45,
    y2: 3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8FAFC"
  })))));
};
export default SvgRar;